import Backbone from 'backbone';
import Cocktail from 'backbone.cocktail';

// https://github.com/onsi/cocktail#if-you-dont-mind-monkeypatching
Cocktail.patch(Backbone);
